/**
 * Platform language mapping
 * Maps trivago locale codes to platform language codes
 * 
 * @example
 * platformsLanguages['en-GB'] // 'en-US'
 * platformsLanguages['de-DE'] // 'de'
 */

export const platformsLanguages = {
  'en-US': 'en-US',
  'en-GB': 'en-US',
  'pl-PL': 'pl',
  'de-DE': 'de',
  'el-GR': 'el',
  'fr-FR': 'fr',
  'it-IT': 'it',
  'es-ES': 'es',
  'pt-BR': 'pt',
  'pt-PT': 'pt',
  'ja-JP': 'ja',
  'es-MX': 'es',
  'nl-NL': 'nl',
  'tr-TR': 'tr',
} as const

/** Union type of supported locale codes (keys) */
export type LocaleCode = keyof typeof platformsLanguages

/** Union type of platform language codes (values) */
export type PlatformLanguage = typeof platformsLanguages[LocaleCode]